const MuiInput = {

};

export default MuiInput;
